import React, { memo, Fragment } from 'react';

export const TableContentFragment = memo(({ id, content }) => (
    <Fragment key={id}>{content}</Fragment>
));
